// import { ProposedToTheSubCommittee3ViewComponent } from "../../../components/borrowSystem/ProposedToTheSubCommittee/ProposedToTheSubCommittee3ViewComponent";
import { ProposedToTheSubCommittee3EditViewComponent } from "../../../components/borrowSystem/ProposedToTheSubCommittee/ProposedToTheSubCommittee3EditViewComponent";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";

export function PoposedToTheSubCommittee3EditContainer() {
    const titleName = "แบบเสนอคณะอนุกรรมการพิจารณาให้กู้ยืมกองทุนพัฒนาฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
    const subtitle = "(สำหรับผู้ดำเนินการฝึกและผู้ประกอบกิจการ)"
    return (
        <div className="page-container bg-landing">
            <NavbarBorrowSystem />
            <HeadTitle title={titleName} subtitle={subtitle} />
            <ProposedToTheSubCommittee3EditViewComponent />
            <Footer />
        </div>

    )
}




